import View from 'mixins/view';
import moment from 'moment/moment';
import 'moment/locale/pl';
import { matchCalendarModel } from 'models/MatchCalendarModel';

export default class extends View {
    constructor(model) {
        super(model);
        this.setRootEl($(`<li class="match-calendarElement"></li>`));
        model.addEventListener('changed', this.checkFocus.bind(this));
    }
    render() {
        const day = moment(this.model.get('day'));

        this.rootEl.html(day.format('D'));

        if (day.format('D') == 1) {
            this.addMonthLabel();
        }

        this.checkFocus();

        if (this.model.get('icon')) {
            this.favour();
        }

        this.rootEl.data('display', moment(this.model.get('day')).format('MMMM YYYY', 'pl'));
    }
    checkFocus() {
        const day = moment(this.model
            .get('day'))
            .format('YYYY-MM-DD');

        const currentDay = moment(matchCalendarModel
            .get('currentDay'))
            .format('YYYY-MM-DD');

        if (day === currentDay) {
            this.rootEl.addClass('match-calendarElement__active');
        } else {
            this.rootEl.removeClass('match-calendarElement__active');
        }
    }
    favour() {
        this.rootEl.addClass('match-calendarElement__contain');
        this.rootEl.html(`
          <span class="circle">
            <span class="day">${moment(this.model.get('day')).format('D')}</span>
            <img src="${this.model.get('icon')}">
          </span>
        `);
        if (this.model.get('count') > 1) {
          this.rootEl.find('.circle').append(`
              <span class="more">+${this.model.get('count') - 1 }</span>
            `);
        }
        this.rootEl.click(() => {
            matchCalendarModel.setCurrentDay(this.model.get('day'));
        });
    }
    addMonthLabel() {
        this.rootEl.prepend($(`
            <div class="month">
              ${moment(this.model.get('day')).format('MMMM YYYY', 'pl')}
            </div>
        `));
    }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/matchCalendar/match-calendar-day-view.js